import React, { useEffect, useState } from "react";
import axios from "axios";
import { useBetween } from "use-between";
import _loading from "_loading";
import DataTableFields from "components/table/DataTableFields";
import { useLocation } from "react-router-dom";
const Data = () => {
  const [data, setData] = useState([]);
  const { state } = useLocation();

  const [columns, setColumns] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [loading, setLoading] = useState(false);

  const loadData = async (pageIndex = 0, pageSize = 10, filters = {}) => {
    setLoading(true);

    const response = await axios.post("/web/devices/data", {
      device_id: (state || {}).device_id,
      page: pageIndex + 1,
      limit: pageSize,
      search: filters.search || "",
      device: filters.device || "",
      startDate: filters.startDate || null,
      endDate: filters.endDate || null,
    });
    if (response.data.success) {
      setColumns(
        response.data.cols.map((col) => ({
          Header: col.n,
          accessor: col.i,
        }))
      );

      const data = response.data.rows;
      setData(data);
      setTotalRecords(response.data.total || 0);
      setPageCount(Math.ceil((response.data.total || 0) / pageSize));
      setPageIndex(pageIndex);
      setLoading(false);
    }
    //console.log(data);
  };

  useEffect(() => {
    //console.log("useEffect");
    loadData();
  }, []);

  return (
    <>
      <div className="mt-3 dark:text-white">
        {loading && <div className="flex justify-left items-center h-full mr-2">
          <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-gray-900 dark:border-white"></div>
        </div>
        }
        <DataTableFields
          columnsData={columns}
          tableData={data}
          title=""
          serverSide={true}
          onFetchData={loadData}
          pageCount={pageCount}
          totalRecords={totalRecords}
          pageIndex={pageIndex}
        />
      </div>


    </>
  );
};

export default Data;
